// Start Laravel 8 Bootstrap Additions
window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// End Laravel 8 Bootstrap Additions

/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.$ = window.jQuery = require('jquery');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
window.Vue = require('vue/dist/vue');

// Require Vue Resource
// require('vue-resource');

// Require Select2
require('select2');

// // Require Vue Trucate Filter.
// var VueTruncate = require('vue-truncate-filter');
// Vue.use(VueTruncate);

// Require EasyAutocomplete
require('easy-autocomplete');

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 *
 * TODO: I'M NOT SURE IF I'M EVEN USING VUE FOR AJAX; COMMENTING TO SEE IF ANY ISSUES.
 * BESIDES, SINCE UPGRADING TO LARAVEL 8, THE HTTP PROPERTY DOESN'T SEEM TO BE DEFINED.
 */
// Vue.http.interceptors.push(function(request, next){
//     request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken);
//
//     next();
// });

// Define global AJAX headers.
$.ajaxSetup({
    headers: {
        // Set the "CSRF" token for all jQuery AJAX requests.
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    }
});

// Require Utils.
// require('./utils');
import './utils';

// Require UiMessageHandler.
// require('./ui-message-handler');
import './ui-message-handler';

// Require JS Cookie.
/**
 * THIS ***STILL*** DOESN'T WORK FOR SOME REASON; WILL RESORT TO SCRIPT TAG
 *
 * The error I'm getting is "ReferenceError: Cookies is not defined"
 *
 * I tried multiple ways, import, import Cookies from 'js-cookie', etc. nothing works; sticking with script tag.
 *
 require('./js.cookie.min');
 */

Vue.config.errorHandler = function (err, vm, info)
{
    Utils.log({
        type: 'Vue',
        message: err.message,
        stack: err.stack,
        component: vm.$options.name,
        info: info,
        url: window.location.href,
    });
};

// Courtesy of ChatGPT4
window.onerror = function (msg, url, lineNo, columnNo, error)
{
    Utils.log({
        type: 'Window',
        message: msg,
        filename: url,
        lineno: lineNo,
        colno: columnNo,
        stack: error.stack,
    });
};

// Require Summary Cart Controller.
import './Models/Orders/summary-cart-controller';

// On document ready.
$(document).ready(function()
{
    // Decode Laravel globals.
    Laravel = Utils.decodeHttp(Laravel);

    // Conditionally decode user.
    if (typeof User !== 'undefined')
    {
        User = Utils.decodeHttp(User);
    }
    else
    {
        window.User = null;
    }

    // Define GeoLocation
    if (Laravel.geoLocation === null && navigator.geolocation)
    {
        navigator.geolocation.getCurrentPosition(function(position)
        {
            $.ajax({
                type: 'GET',

                url: APP_URL +'/geocode',

                data:
                {
                    coordinates: [position.coords.latitude, position.coords.longitude]
                },

                // On non-application error.
                error: function()
                {
                    console.log('Set GeoLocation failed.');
                }
            });
        });
    }
});

window.testAuthFormRecaptcha = function(token)
{
    document.getElementById('recaptchaToken').value = token;
    document.authForm.submit();
};
